import React, { useState, useEffect } from 'react'
import classes from './OtpPage2.module.css'
import { v4 as uuidv4 } from 'uuid';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { loginApi, SendOtpAPI, VerifyOtpAPI } from '../../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../../store/slices/userSlice'
import { toast } from 'react-toastify'
import SmallLoader from '../../component/SmallLoader'
import { useTranslation } from 'react-i18next';
import i18n from '../../locales/i18n';
import { setLanguage } from '../../store/slices/languageSlice';
import OTPInput from 'react-otp-input';
import { FaArrowLeft } from 'react-icons/fa6';

const OtpPage2 = () => {

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const [msisdn, setMsisdn] = useState("");
    const [pack, setPack] = useState(null);
    const [extRef, setExtRef] = useState(null);
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [packNo, setPackNo] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    console.log(selectedLanguage,'sl');

    const { t } = useTranslation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setPack(location?.state?.pack);
            setPackNo(location?.state?.packNo);
        }
        else {
            navigate("/");
        }
    }, [location]);

    useEffect(() => {
        if (selectedLanguage && i18n.language !== selectedLanguage) {
            i18n.changeLanguage(String(selectedLanguage));
        }
    }, [selectedLanguage, i18n]);

    useEffect(() => {
        if (userDetails?.token) {
            navigate("/home");
        }
    }, [userDetails]);

    const handleFormSubmission = async () => {
        try {
            if (otp.length <= 3) {
                return;
            }
            setLoading(true);
            const response = await VerifyOtpAPI(msisdn, otp);
            setLoading(false);
            navigate("/confirmation", {
                state: {
                    msisdn: msisdn,
                    extRef: extRef,
                    pack: pack,
                    packNo: packNo
                }
            })

        } catch (error) {
            setLoading(false);
            console.log(error, 'error---');

            if (error?.response?.data?.status == 0) {
                toast.error(t("233"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.info(t("234"));
            }
            else {
                toast.error(t("20"));
            }
        }
    }

    const resendOtpHandler = async () => {

        try {
            setResendLoading(true);
            const response = await SendOtpAPI(msisdn);
            setTimer(120);
            setResendLoading(false);
            setResend(true);
            setOtp("");
            toast.success(t("235"));
        } catch (error) {
            setResendLoading(false);
            toast.error(t("20"));
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);

    return (
        <div className={classes.page}>

            <select
                id="lang"
                name="lang"
                className={classes.dropdown}
                value={selectedLanguage}
                onChange={(event) => {
                    dispatch(setLanguage(event.target.value));
                }}
            >
                <option value="0">English</option>
                <option value="1">French</option>
            </select>

            {/* ══ LEFT — Brand Hero ══ */}
            <div className={classes.leftPanel}>
                <div className={classes.arcCircle} />

                {/* Logo */}
                {/* <div className={classes.logo}>
                    <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
                </div> */}

                {/* Hero copy */}
                <h1 className={classes.heroTitle}>
                    {t("224")}
                </h1>

                <div className={classes.container}>
                    <button className={classes.back_button}
                    onClick={()=>navigate(-1)}
                    >
                        <FaArrowLeft color='#fff' />
                    </button>
                    <p className={classes.sectionLabel}>
                        {resend ? t("226") : t("225")} {" "}
                        {t("227")}
                        <span className={classes.bold}> +233 {msisdn} </span>
                        {t("228")}
                    </p>

                    <div className={classes.otp_input_container}>
                        <OTPInput
                            value={otp}
                            shouldAutoFocus
                            onChange={setOtp}
                            numInputs={4}
                            renderSeparator={<span className={classes.gap}></span>}
                            renderInput={(props) => (
                                <input {...props} type="number" className={classes.input_box} />
                            )}
                        />
                    </div>

                        {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                    <SmallLoader />
                </div> : (
                    <div className={classes.btn_container}>
                        <button
                            type="button"
                            className={classes.confirm_btn}
                            disabled={loading}
                            onClick={handleFormSubmission}
                        >
                            {t("231")}
                        </button>
                        <button
                            type="button"
                            className={classes.resend_btn}
                            disabled={resendLoading}
                            onClick={resendOtpHandler}
                        >
                            {t("232")}
                        </button>
                    </div>
                )}
                </div>

            

                <div className={classes.time_container}>
                    <p className={classes.time_text}>{t("229")} {timer} {t("230")}</p>
                </div>

            </div>

                 <div className={classes.copyrightFooter}>
                                    <div className={classes.copyrightDivider} />
                                    <div className={classes.copyrightInner}>
                                        <span className={classes.copyrightBadge}>
                                            <span className={classes.copyrightBadgeIcon}>⚽</span>
                                            Football Masters
                                        </span>
                                        <p className={classes.copyrightText}>
                                            © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                                        </p>
                                        <p className={classes.copyrightSub}>All rights reserved</p>
                                    </div>
                                </div>

            {/* ══ RIGHT — Form ══ */}
            {/* <div className={classes.rightPanel}>
                <div className={classes.formContainer}>

                    <h2 className={classes.formTitle}>
                        {t("7")} <span>{t("8")}</span>
                    </h2>
                    <p className={classes.formSubtitle}>
                        {t("9")}
                    </p>

                    <div className={classes.tabToggle}>
                        <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
                            {t("10")}
                        </button>
                        <button
                            type="button"
                            className={classes.tab}
                            onClick={() => navigate(`/?ext_ref=${extRef}`)}
                        >
                            {t("11")}
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmission}>

                        <p className={classes.sectionLabel}>{t("12")}</p>
                        <div className={classes.phoneRow}>
                            <div className={classes.countryPill}>
                                <img src="/assets/images/flag.png" alt="India" className={classes.flag} />
                                <span className={classes.dialCode}>+233</span>
                            </div>
                            <input
                                id="msisdn"
                                name="msisdn"
                                type="number"
                                autoFocus
                                onWheel={(e) => e.target.blur()}
                                placeholder={t("13")}
                                className={classes.phoneInput}
                                onChange={(e) => setMsisdn(e.target.value)}
                                value={msisdn}
                            />
                        </div>

                        <div className={classes.termsRow}>
                            <input
                                type="checkbox"
                                id="terms"
                                name="Terms & Conditions"
                                value="Terms"
                                className={classes.termsCheck}
                                checked
                                readOnly
                            />
                            <label htmlFor="terms" className={classes.termsText}>
                                {t("14")}{" "}
                                <span className={classes.termsLink}>{t("15")}</span>
                            </label>
                        </div>

                        <button type="submit" disabled={loginLoading} className={classes.ctaBtn}>
                            {loginLoading
                                ? <SmallLoader style={{ border: "4px solid #0f0e0d" }} />
                                : <>{t("16")}</>
                            }
                        </button>

                    </form>

                    <p className={classes.switchPrompt}>
                        {t("17")}{" "}
                        <span
                            className={classes.switchLink}
                            onClick={() => navigate(`/?ext_ref=${extRef}`)}
                        >
                            {t("18")}
                        </span>
                    </p>

                    <div className={classes.copyrightFooter}>
                        <div className={classes.copyrightDivider} />
                        <div className={classes.copyrightInner}>
                            <span className={classes.copyrightBadge}>
                                <span className={classes.copyrightBadgeIcon}>⚽</span>
                                Football Masters
                            </span>
                            <p className={classes.copyrightText}>
                                © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                            </p>
                            <p className={classes.copyrightSub}>All rights reserved</p>
                        </div>
                    </div>


                </div>
            </div> */}

        </div>
    )
}

export default OtpPage2